import React from 'react';
import { observer } from "mobx-react-lite";
import { PlacementSelectorLoadingBar, PlacementSelectorLayerSelection, PlacementSelectorGamePreviewCheckmark, PlacementSelectorHeadline, TileAssetPlacementButtons, PlacementSelectorAssetSearch, TileCategoryMenu, ContainerUnderHeadline } from '../mapEditor/PlacementSelectorComponents';
import styled from 'styled-components';
import { MenuCard } from '../menu/MenuCard';
import { tileAssetEditorStore } from '../../stores/TileAssetEditorStore';
import { SearchFilterCategory } from '../../stores/MapRelatedStore';
import { useTranslation } from 'react-i18next';
import { tileVisibilities, TileVisibility } from '../../../shared/resources/TileAssetModel';
const Container = styled.div.withConfig({
  displayName: "TileAssetEditorTileSelector__Container",
  componentId: "sc-3wrf7p-0"
})(["display:flex;flex-grow:1;overflow:hidden;"]);
const InnerContainer = styled(MenuCard).withConfig({
  displayName: "TileAssetEditorTileSelector__InnerContainer",
  componentId: "sc-3wrf7p-1"
})(["overflow:inherit;flex:1;"]);
export const PlacementSelectorComplexitySelection = observer(() => {
  const {
    t
  } = useTranslation();
  const {
    onlyShowVisibility
  } = tileAssetEditorStore;
  return /*#__PURE__*/React.createElement(React.Fragment, null, t("editor.tile_asset_visibility_in_editor"), ":\xA0", /*#__PURE__*/React.createElement("select", {
    value: onlyShowVisibility != null ? onlyShowVisibility : "",
    onChange: e => tileAssetEditorStore.setOnlyShowVisibility(e.target.value === "" ? null : +e.target.value)
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }), tileVisibilities.map(visibility => /*#__PURE__*/React.createElement("option", {
    key: visibility,
    value: visibility
  }, t("editor.tile_asset_visibility_" + TileVisibility[visibility])))));
});
export const TileAssetEditorTileSelector = observer(() => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PlacementSelectorLoadingBar, null), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TileCategoryMenu, {
    mapRelatedStore: tileAssetEditorStore,
    skipMainCategories: false
  })), /*#__PURE__*/React.createElement(InnerContainer, null, /*#__PURE__*/React.createElement(PlacementSelectorHeadline, null, /*#__PURE__*/React.createElement(PlacementSelectorLayerSelection, {
    mapRelatedStore: tileAssetEditorStore
  }), "\xA0 | \xA0", /*#__PURE__*/React.createElement(PlacementSelectorAssetSearch, {
    mapRelatedStore: tileAssetEditorStore,
    category: SearchFilterCategory.TileAsset
  }), "\xA0 | \xA0", /*#__PURE__*/React.createElement(PlacementSelectorComplexitySelection, null), "\xA0 | \xA0", /*#__PURE__*/React.createElement(PlacementSelectorGamePreviewCheckmark, {
    mapRelatedStore: tileAssetEditorStore
  })), /*#__PURE__*/React.createElement(ContainerUnderHeadline, null, /*#__PURE__*/React.createElement(TileAssetPlacementButtons, {
    showEmpty: true,
    tileAssets: tileAssetEditorStore.filteredTileAssets,
    mapRelatedStore: tileAssetEditorStore
  })))));
});